import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

// Components

// Configs
import { DialogConfig } from 'v2/modules/shared/configs/dialog.config';
import { SnackBarConfig } from 'v2/modules/shared/configs/snackbar.config';
import { UiConfirmationDialogComponent } from 'v2/modules/ui/components/ui-confirmation-dialog/ui-confirmation-dialog.component';

// Services
import { OrderSalesApiService } from '../../api/order/order-sales-api.service';
import { LoadingDialogUtilService } from '../../util/loading-dialog-util.service';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderFulfillmentFacadeService {
  private onDestroy$ = new Subject<void>();

  constructor(
    private dialog :MatDialog,
    private snackBar :MatSnackBar,
    private loadingDialogService :LoadingDialogUtilService,
    private orderSalesApiService :OrderSalesApiService,
  ) {}

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  pushFulfillment(salesOrderId :number, successCallback :() => void) :void {
    this.dialog
      .open(UiConfirmationDialogComponent, {
        data: {
          title: 'Push Tracking to Sales Channel',
          message:
            "This action will push the sales order's fulfillment information. Proceed?",
        },
        width: DialogConfig.sizes.small,
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe((confirm :boolean) => {
        if (confirm) {
          this.loadingDialogService.show('Pushing fulfillment...');

          this.orderSalesApiService
            .pushFulfillment(salesOrderId)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe({
              next: (response :any) => {
                this.loadingDialogService.close();
                this.snackBar.open(response.success, 'Success', {
                  duration: SnackBarConfig.DEFAULT.duration,
                });

                successCallback();
              },
              error: (response :any) => {
                this.loadingDialogService.close();
                this.snackBar.open(response.error, 'Fail', {
                  duration: SnackBarConfig.DEFAULT.duration,
                });

                successCallback();
              },
            });
        }
      });
  }
}
